import styles from './EmptyCartPopUp.module.css';
import Image from '../../../Image';
import Button from '../../../Button';
import { FC } from 'react';
import { EmptyCartPopUpProps } from './types';

const EmptyCartPopUp: FC<EmptyCartPopUpProps> = ({ redirectStart, handleClose }) => (
  <div className={styles.empty}>
    <p className={styles.emptyText}>Your shopping cart is empty</p>
    <div className={styles.cartImage}>
      <Image layout="fill" src={'/marketplace-static/images/icons/shoping-cart-empty.svg'} alt="shoppin-cart-empty" />
    </div>

    <div className={styles.buttonContainer}>
      <Button
        fullWidth
        loading={redirectStart}
        size={'medium'}
        variant={'secondary'}
        label={<p className={styles.proceedCheckoutButtonText}>Keep Shopping</p>}
        onClick={handleClose}
      />
    </div>
  </div>
);

export default EmptyCartPopUp;
